import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from '@i18n';
import {
  Table,
  withLayout,
  Section,
  useFirstRender,
} from '@casanova/casanova-common';
import { CellText, CellStatus } from 'components/ColumnsCells';

function VehicleStatusDetails({
  match,
  vehicleStatusDetails = [],
  fetchVehicleStatusDetails,
  onlyFetchParams = false,
}) {
  console.log('vehicleStatusDetails', vehicleStatusDetails);
  const vehicleStatusDetailsFormatted = [
    vehicleStatusDetails.reduce((acc, item) => {
      const { name, active } = item;
      acc[name] = active;
      return acc;
    }, {}),
  ];
  console.log('vehicleStatusDetailsFormatted', vehicleStatusDetailsFormatted);
  const columns = [
    'a0c3f94f-36df-492e-bd79-a09008b31ab0',
    'cecf426b-0f21-4ccf-9e4c-793005c105e5',
    '8b022103-40d7-4b65-b536-d808e1823121',
    'f3f726fd-20d6-4f31-ba23-eccc0215e422',
    'a9ffc9cc-b5dc-4bd9-b4a3-3a58755160b1',
    '0952b7e3-3ce0-4628-86b0-28a0fcc6021f',
    'acbbd94b-b2c2-4647-8434-1879a6cf9062',
  ]
    .map((id) => vehicleStatusDetails.find((item) => item.uuid === id))
    .filter(Boolean)
    .map((item) => ({
      label: item.name,
      field: item.name,
      align: 'left',
      // renderer: (value) => {
      //   console.log('--- Debugging renderer ---');
      //   console.log('value:', value);
      //   return value ? (
      //     <span>Si</span>
      //   ) : (
      //     <span style={{ color: 'red' }}>No</span>
      //   );
      // },
      renderer: CellStatus,
    }));
  console.log('columns', columns);

  const isFirstRender = useFirstRender();

  const vehicleUuid = useMemo(() => match.params.id, [match.params.id]);

  useEffect(() => {
    console.log('--- Debugging useEffect fetchVehicleStatusDetails ---');
    console.log('vehicleUuid:', vehicleUuid);
    console.log('onlyFetchParams:', onlyFetchParams);
    console.log('isFirstRender:', isFirstRender);
    console.log('Condition:', onlyFetchParams ? !isFirstRender : true);
    if (onlyFetchParams ? !isFirstRender : true) {
      console.log('call fetchVehicleStatusDetails');
      fetchVehicleStatusDetails({ uuid: vehicleUuid });
    }
  }, [vehicleUuid, onlyFetchParams]);

  if (!vehicleStatusDetails || vehicleStatusDetails.length === 0) {
    return null;
  }

  return (
    <Section title={i18n('VEHICLES__SECTIONS__VEHICLE_STATUS_DETAILS__TITLE')}>
      <Table
        primary
        emptyMessage={i18n('ERROR__COMMONS__NOT_FOUND')}
        dataList={vehicleStatusDetailsFormatted}
        columns={columns}
      />
    </Section>
  );
}

VehicleStatusDetails.propTypes = {
  onlyFetchParams: PropTypes.bool,
};

export default withLayout(VehicleStatusDetails, { withLoader: false });
